import { createFileRoute } from '@tanstack/react-router'
import { PipelineReportPage } from '@/features/candidates/components/pipeline-report-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/pipeline-report',
)({
  component: PipelineReportPage,
  beforeLoad: () => ({
    title: 'Pipeline Report',
    headerTitleKey: 'header.pipelineReport.title',
    headerDescriptionKey: 'header.pipelineReport.description',
  }),
})
